import React from 'react';
import { useTranslation } from 'react-i18next';
import { CardsSection } from 'components/layout/Section/CardsSection';
import { NsKey } from 'enums/NsKey';
import { useQuoteContractualizationData } from '../../store';
import { ValidationCard } from '../cards/ValidationCard';

/**
 * Quote validation section, between the file information and the signatures. Absent when
 * the tunnel does not ask this broker for a validation.
 */
export const ValidationSection: React.FC = () => {
  const { t } = useTranslation(NsKey.Contractualization);
  const quoteData = useQuoteContractualizationData();
  const validation = quoteData?.validation;

  if (!validation || validation.mode === 'Absente') return null;

  return (
    <CardsSection title={t('CONTRACTUALIZATION.CARDS.VALIDATION_SECTION')}>
      <ValidationCard />
    </CardsSection>
  );
};
